import Vue from 'vue';
import * as clipboard from 'clipboard-polyfill/dist/clipboard-polyfill.promise';
import tooltip from '@/mixins/components/tooltip';

export default Vue.component('edit-modal', {
  template: require('./template.html'),
  name: 'edit-modal',
  props: ['droplet', 'show-edit-bubble'],
  data() {
    return {
      copied: false,
      display: {
        pageLoad: false,
        blur: false,
      },
    };
  },
  components: {
    tooltip,
  },
  watch: {
    showEditBubble(open) {
      if (open) {
        this.setInitialValies();
      }
    },
  },
  methods: {
    setInitialValies() {
      this.display.pageLoad = this.droplet.pageLoad;
      this.display.blur = this.droplet.blur;
    },
    copyText(text) {
      clipboard.writeText(text).then(() => {
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 1500);
      });
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/modal/components/_edit-options/index.js